// @flow
export const CONTACT_FORM_MODAL = 'modal.contactForm'
export const DELETE_CONTACT_MODAL = 'modal.deleteContact'

export const MYCHARITY_RESOURCE = 'myCharity'
export const MYCHARITY_AUCTIONS_RESOURCE = 'myCharity/auctions'

export const FETCH_MYCHARITY_REQUEST = 'FETCH_MYCHARITY_REQUEST'
export const FETCH_MYCHARITY_SUCCESS = 'FETCH_MYCHARITY_SUCCESS'
export const FETCH_MYCHARITY_FAILED = 'FETCH_MYCHARITY_FAILED'

export const FETCH_MYCHARITY_AUCTIONS_REQUEST =
  'FETCH_MYCHARITY_AUCTIONS_REQUEST'
export const FETCH_MYCHARITY_AUCTIONS_SUCCESS =
  'FETCH_MYCHARITY_AUCTIONS_SUCCESS'
export const FETCH_MYCHARITY_AUCTIONS_FAILED = 'FETCH_MYCHARITY_AUCTIONS_FAILED'

export const PUBLIC_AUCTIONS_TAB_INDEX = 'publicAuctions'

export const MY_AUCTIONS_SET = 'myAuctions'

export const CLEAR_MYCHARITY = 'CLEAR_MYCHARITY'

export const STORE_CHARITY = 'STORE_CHARITY'

export const UPDATE_CHARITY_RESOURCE = 'update:charity'
export const UPDATE_CHARITY_REQUEST = 'UPDATE_CHARITY_REQUEST'
export const UPDATE_CHARITY_SUCCESS = 'UPDATE_CHARITY_SUCCESS'
export const UPDATE_CHARITY_FAILED = 'UPDATE_CHARITY_FAILED'



// WEBPACK FOOTER //
// ./src/services/mycharity/charity/constants.js